import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import magic from '@/service/magic';
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue';
import LotteryPop from '../Pop/LotteryPop/LotteryPop.vue';
import UsePop from '../Pop/UsePop/UsePop.vue';
export default {
  components: {
    SvgIcons: SvgIcons,
    LotteryPop: LotteryPop,
    UsePop: UsePop
  },
  data: function data() {
    return {
      showLotteryRes: false,
      // 是否展示抽奖结果弹窗
      lotteryResOptions: null,
      // 抽奖结果信息
      lotterying: false,
      // 是否正在抽奖
      showUsePop: false,
      // 是否展示用户操作规则弹窗
      lotteryHit: null,
      // 抽中奖动画对象
      LotteryNoHit: null,
      // 未抽中奖对象
      isShowHitAnimation: false,
      // 是否展示抽中奖动画
      isShowNoHitAnimation: false // 是否展示未抽中奖动画

    };
  },
  computed: {
    // 剩余抽奖次数
    remainNum: function remainNum() {
      return this.$store.state.remainNum;
    }
  },
  methods: {
    // 选择礼包
    selectGiftPack: function selectGiftPack(k) {
      if (k === 2 && this.hasTicket) {
        var url = this.setting.云首发特权三.高清剧照跳转链接;
        this.openUrl(url);
      }
    },
    // 抽奖前置判断
    doLottery: function doLottery() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.loginService.isLogin) {
                  _context.next = 3;
                  break;
                }

                _this.$openLogin();

                return _context.abrupt("return");

              case 3:
                if (_this.remainNum) {
                  _context.next = 6;
                  break;
                }

                _this.openPay();

                return _context.abrupt("return");

              case 6:
                if (!_this.lotterying) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                // 开始抽奖
                _this.lotterying = true;
                _context.prev = 9;
                _context.next = 12;
                return _this.lottery();

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](9);
                _this.lotterying = false;

              case 17:
                _this.lotterying = false;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 14]]);
      }))();
    },
    // 执行抽奖
    lottery: function lottery() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, ret, data, code, msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return magic.lottery();

              case 3:
                res = _context2.sent;
                ret = +res.ret;
                data = res.data;
                code = +data.sys_code;

                if (ret === 0) {
                  _this2.refreshLotteryInfo();

                  if (code === 0) {
                    // todo 显示奖品弹窗
                    _this2.showLottery({
                      pic: data.lottery_url,
                      name: data.lottery_name,
                      type: 1
                    });
                  } else if (code === -100) {
                    // todo 显示未中奖的信息
                    _this2.showLottery({
                      pic: '//puui.qpic.cn/vupload/0/1587556711440_kvy9co59sg.png/0'
                    });
                  } else {
                    _this2.toast(data.lottery_txt);
                  }
                } else if (ret === -905) {
                  // 未通过安全策略
                  _this2.shieldRun(res.security_verify, function () {
                    _this2.lottery();
                  });
                } else {
                  _this2.toast(data.lottery_txt);
                }

                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                msg = _context2.t0.message || _context2.t0.msg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(_context2.t0.code, ")");

                _this2.toast(msg);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }))();
    },
    // 展示抽奖结果
    showLottery: function showLottery(options) {
      var _this3 = this;

      this.lotteryResOptions = options;
      var func = options.type === 1 ? this.playHitAnimation : this.playNoHitAnimation;
      func(function () {
        _this3.showLotteryRes = true;
      });
    },
    // 刷新抽奖信息
    refreshLotteryInfo: function refreshLotteryInfo() {
      return this.$store.dispatch('refreshLotteryInfo');
    },
    // 抽中奖
    playHitAnimation: function playHitAnimation(cb) {
      var _this4 = this;

      this.isShowHitAnimation = true;

      if (this.lotteryHit) {
        this.lotteryHit.play();
        return;
      }

      this.lotteryHit = window.bodymovin.loadAnimation({
        path: 'https://m.film.qq.com/static/ysf/lottie/hit/data.json',
        loop: true,
        autoplay: true,
        renderer: 'svg',
        // 渲染方式，有"html"、"canvas"和"svg"三种
        container: this.$refs.lotteryHit
      });
      this.lotteryHit.addEventListener('loopComplete', function () {
        // 停止动画
        _this4.lotteryHit.stop(); // 隐藏动画弹层


        _this4.isShowHitAnimation = false;
        cb();
      });
    },
    // 未抽中奖
    playNoHitAnimation: function playNoHitAnimation(cb) {
      var _this5 = this;

      this.isShowNoHitAnimation = true;

      if (this.LotteryNoHit) {
        this.LotteryNoHit.play();
        return;
      }

      this.LotteryNoHit = window.bodymovin.loadAnimation({
        path: 'https://m.film.qq.com/static/ysf/lottie/nohit/data.json',
        loop: true,
        autoplay: true,
        renderer: 'svg',
        // 渲染方式，有"html"、"canvas"和"svg"三种
        container: this.$refs.lotteryNoHit
      });
      this.LotteryNoHit.addEventListener('loopComplete', function () {
        // 停止动画
        _this5.LotteryNoHit.stop(); // 隐藏动画弹层


        _this5.isShowNoHitAnimation = false;
        cb();
      });
    },
    // 播放灯的动画
    playLight: function playLight() {
      var _this6 = this;

      setTimeout(function () {
        window.bodymovin.loadAnimation({
          path: 'https://m.film.qq.com/static/ysf/lottie/light/data.json',
          loop: true,
          autoplay: true,
          renderer: 'svg',
          // 渲染方式，有"html"、"canvas"和"svg"三种
          container: _this6.$refs.lotteryLight
        });
      }, 2000);
    }
  },
  mounted: function mounted() {
    this.playLight();
  }
};